import {
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	Text,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import { ChevronRight, Close } from '@volkswagen-onehub/icons-core';
import { InteractionLayerSizeV2, LayerHandleV2, ShimBackgroundTypeV2 } from '@volkswagen-onehub/layer-manager';
import React from 'react';
import styled from 'styled-components';
import { PortalContext } from '../../../context/PortalContext';
import { VehicleNotification, VehicleNotificationType } from '../notifications-types';
import { Vehicle } from '@esportal/portal-service/src/models/vehicles';
import { Environment } from '../../../enviroment';
import { actionRedirect } from '../../../helpers/common-helpers';
import { getNotificationMessage, getNotificationTag } from '../utils';

const NotificationContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	padding: var(--size-dynamic0100) 0;
	position: relative;
	cursor: pointer;
	border-bottom: 1px solid #dfe4e8;

	& > svg {
		min-width: fit-content;
		min-height: fit-content;
	}

	&::before {
		content: '';
		position: absolute;
		top: calc(var(--size-dynamic0100) + 3px);
		left: -18px;
		width: 10px;
		height: 10px;
		border-radius: 50%;
		background-color: rgb(26, 216, 77);
	}
`;

export function HeaderNotificationsLayer({
	isOpen,
	handleClose,
	notifications,
}: {
	isOpen: boolean;
	handleClose: () => void;
	notifications: VehicleNotification[];
}) {
	const { layerManager, navigationService, userInteractionService } = React.useContext(PortalContext);
	const layerRef = React.useRef<LayerHandleV2<{}> | null>(null);

	const handleClickAlert = async (vehicle: Vehicle | undefined, notificationType: VehicleNotificationType) => {
		// trackingManager.trackClubVWButtonClick(
		//     'Alerts',
		//     { contentId: `Alert ${alertType}` },
		//     { vehicle: formatOwnership(vehicle ? [vehicle] : []) },
		// );

		if (notificationType === VehicleNotificationType.Mantenimiento && vehicle) {
			const environmentPath = Environment.getInstance().maintenancePage as string;
			const search = window.location.search;
			const target = navigationService.navigateTo(environmentPath, {});

			if (target) {
				target.push();
				const href = target.createHref();
				addParamToUrl(href, vehicle.frame, search);
			}
		}

		if (notificationType === VehicleNotificationType.PreITV && vehicle) {
			actionRedirect(userInteractionService, 'action:es-cca-loader--open_layer');
		}
	};

	const addParamToUrl = (href: string, param: string, search: string) => {
		const newSearchParams = new URLSearchParams(search);
		newSearchParams.append('frame', param);
		window.history.replaceState(null, '', href + `?${newSearchParams.toString()}`);
	};

	React.useEffect(() => {
		if (layerRef.current || !isOpen) return;

		layerRef.current = layerManager.openInteractionLayer(
			() => (
				<Container
					wrap="always"
					padding={ContainerPadding.dynamic0150}
					horizontalAlign="center"
					gutter={ContainerGutter.static400}
				>
					<Container wrap={'never'} horizontalAlign={'space-between'}>
						<Text appearance={TokenTextAppearance.headline400}>Notificaciones</Text>
						<CTA
							tag="button"
							emphasis="tertiary"
							onClick={handleClose}
							aria-label="Close pop-up"
							icon={<Close variant="default" aria-hidden />}
						/>
					</Container>

					<Container wrap="always">
						{notifications.map((notification, index) => (
							<NotificationContainer
								onClick={() => handleClickAlert(notification.vehicle, notification.notificationType)}
							>
								<Container key={index} wrap="always" gutter={ContainerGutter.static150}>
									<Container wrap="always">
										<Text color={TokenTextColor.secondary} bold appearance={TokenTextAppearance.label150}>
											{getNotificationTag(notification.notificationType)}
										</Text>
										{/* <Text color={TokenTextColor.secondary} appearance={TokenTextAppearance.label150}>
											{notification.date.toLocaleDateString('es-ES', {
												day: '2-digit',
												month: 'short',
											})}
										</Text> */}
									</Container>
									<Text bold appearance={TokenTextAppearance.headline100}>
										{getNotificationMessage(notification.notificationType, notification.vehicle.comercialDenomination)}
									</Text>
								</Container>
								<ChevronRight variant="default" aria-hidden />
							</NotificationContainer>
						))}
					</Container>
				</Container>
			),
			{},
			{
				size: InteractionLayerSizeV2.A,
				shimBackgroundType: ShimBackgroundTypeV2.OPAQUE,
			},
		);

		return () => {
			layerRef.current?.close();
			layerRef.current = null;
		};
	}, [isOpen, layerManager]);

	return null;
}
